import React from 'react';
import {FormattedHTMLMessage} from 'react-intl';

import BasicTemplate from './BasicTemplate.js'
import { WAButton, PhoneButton } from '../components/Button.js';


function Rejected(props) {
    return (
        <BasicTemplate>
            <FormattedHTMLMessage id="app.step_rejected" description="Rejected Info"/>
            <WAButton phone="5492615977920" text="Tengo+una+consulta" value="261 5977-920" gaEvent="true" gaCategory="CallToAction" gaAction="WhatsApp Tapping" gaLabel="261-386-6900" />
            <FormattedHTMLMessage id="app.whatsapp_timetable" description="Wp timetable"/>
            <PhoneButton phone="2614253636" value="261 4253-636" gaEvent="true" gaCategory="CallToAction" gaAction="Phone Call Tapping" gaLabel="261-4230-102" />
            <FormattedHTMLMessage id="app.whatsapp_timetable" description="Phone timetable"/>
            <p>Nuestro correo:</p>
            <p><b><a className='email-link' href="mailto:info@mendozafiduciaria.com">info@mendozafiduciaria.com</a></b></p>
        </BasicTemplate>
        );
};
export default Rejected;


/** WEBPACK FOOTER **
 ** ./src/components/Rejected.js
 **/